module.exports = __webpack_public_path__ + "img/8A3B3D_DA5F62_461F20_BC7F81-256px.66545dcf.png";